import { Link, useSearchParams } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  const [searchParams] = useSearchParams();
  const activeCat = searchParams.get('cat') || '';

  return (
    <nav className="flex flex-wrap gap-2" aria-label="分类导航">
      <Link
        to="/category"
        className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
          !activeCat
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category?cat=${cat.id}`}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
            activeCat === cat.id
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500'
          }`}
        >
          <i className={`${cat.icon} mr-1.5 text-xs`}></i>
          {cat.name}
        </Link>
      ))}
    </nav>
  );
}